export const Linedata = (canvas) => {
  const ctx = canvas.getContext('2d')
  const gradient1 = ctx.createLinearGradient(10, 10, 255, 1)
  gradient1.addColorStop(0, ' lightblue')
  gradient1.addColorStop(1, '#F5F8FF')
  return {
    labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    datasets: [
      {
        label: 'My First Dataset',
        data: [4, 7, 6, 8, 11, 5, 3, 4, 7, 9, 10, 9, 8],
        pointRadius: 0,
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: gradient1,
        tension: 0.4,
        fill: true,
      },
    ],
  }
}
export const Linedataoptions = {
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          drawOnChartArea: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'Months',
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          drawOnChartArea: false,
        },
        scaleLabel: {
          display: true,
          labelString: 'Absent%',
        },
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 4,
          stepSize: 3,
        },
      },
    ],
  },
}

export default { Linedata, Linedataoptions }
